import {
  EventBusInterceptor,
  UseService,
  ApiServiceHandler
} from '@haskoning/js-api-authentication-management'
import SHIP_API from '@/api/shipApiUrls'
import { useEventsBus } from '@haskoning/vue-component-library'

export const { emit } = useEventsBus()

const interceptor = new EventBusInterceptor(emit)

const baseURL = import.meta.env.VITE_APP_SHIP_API_BASE_URL
const apiServiceHandler = new ApiServiceHandler(
  baseURL,
  SHIP_API.TOKEN.INDEX,
  SHIP_API.TOKEN.REFRESH,
  interceptor,
  'accessShipApi',
  'refreshShipApi'
)

export const useShipAPI = () => {
  const api = new UseService(apiServiceHandler)
  return { api }
}
